export const environment = {
  production: true,
  /** When true, use mocked Teams context for local development (no Teams SDK required) */
  isLocal: false,
  baseURL: 'https://admin.prod.theloops.ai/v1',
  /** Cube.js API base URL; requests to /load will show in Network tab */
  cubejsURL: 'https://admin.prod.theloops.ai/cubejs-api/v1',

  /** Default app ID for API paths (from /teams/authorize) */
  appId: '2',
  envName: 'prod',
  agentHomepageBaseUrl: 'https://agenthomepage.theloops.ai',
  reactAppBaseUrl: 'https://#tenantId#.theloops.ai'
};
